import { View, TouchableOpacity, StyleSheet, Image } from "react-native";
import { Chip, Text } from "react-native-paper";
import { forwardRef, useCallback, useMemo } from "react";
import { useNavigation } from "@react-navigation/native";
import { ImmersiveNewsArticleRouteProp } from "../../../shared/types/RootStackParamList";
import { ROUTES } from "../../../shared/constants/routes";
import { useThemeSettings } from "../../../ThemeProvider";
import { useCollectionStore } from "../../../store/collectionStore";
import { Article } from "../../../shared/types/DataTypes";
import { getImageUri } from "../../../shared/helpers/utils";
import getGlobalStyles from "../../../globalStyles";
import { formatArticleDate } from "../../../shared/helpers/formatDate";
import { CustomIcon } from "../../../components/CustomIcon";
import { ModalType, useModalStore } from "../../../store/modalStore";

interface ArticleCardProps {
    article: Article;
    height?: number;
}
export const MiniArticleCard = forwardRef<View, ArticleCardProps>(({ article, height, }, ref) => {
    const { theme } = useThemeSettings();
    const gStyles = useMemo(() => getGlobalStyles(theme), [theme]);
    const { selectedCollection } = useCollectionStore();
    const navigation = useNavigation<ImmersiveNewsArticleRouteProp>();
    const setModalShown = useModalStore((state) => state.setModalShown);
    const onCardPress = useCallback(() => {
        // Set the active article ID when card is pressed
        setModalShown(ModalType.NONE);
        (navigation as any).navigate(ROUTES.IMMERSRSIVE_NEWS_ARTICLE, { articleId: article?.id, collectionId: selectedCollection?.id });
    }, [article?.id]);
    return (
        <View key={article.id} style={[styles.gridItem,]}>
            <TouchableOpacity style={[styles.card, { borderColor: theme?.colors?.primary, backgroundColor: theme?.colors?.chatBgAssistant  }]} activeOpacity={0.85} onPress={() => onCardPress()}>
                <Image source={getImageUri(article?.image!)} style={styles.image} />
                <View style={[gStyles.centerColumn]}>
                    <View style={[gStyles.centerRow, {justifyContent: 'space-between', width:140, marginRight:10}]}>
                    {article?.date && (
                        <Chip
                            mode="outlined"
                            style={[gStyles.categoryChip, { maxWidth: 90, marginTop: 5, marginLeft: 5, flex:1 }]}
                            textStyle={{ ...theme.fonts.titleSmall, marginLeft: 8, marginRight: 8, marginVertical: 2, color: '#fff' }}
                        >
                            {formatArticleDate(article.date, 'en-US')}
                        </Chip>)}
                        <TouchableOpacity style={[gStyles.buttonStyle, gStyles.buttonCircle,{height:16, width:16}]} onPress={onCardPress}>
                    <CustomIcon icon="chevron-right" color={theme?.colors?.primary} size={12} />
                  </TouchableOpacity>
                  </View>
                    <Text numberOfLines={3} style={[styles.title, { color: theme?.colors?.textPrimary }]} >
                        {article.title}
                    </Text>
                </View>
            </TouchableOpacity>
        </View>
    );
});

const styles = StyleSheet.create({

    gridItem: {
        maxWidth: 200,
        marginBottom: 0,
    },

    /* Card */
    card: {
        flexDirection: "row",
        borderRadius: 14,
        borderWidth: 1,
        borderColor: "rgba(139,74,74,0.5)",
        minHeight: 75,
        overflow: "hidden",
    },

    image: {
        width: 46,
        minHeight: 75,
        backgroundColor: "#E0E0E0",
    },

    title: {
        flex: 1,
        marginTop: 'auto',
        fontSize: 12,
        lineHeight: 16,
        fontWeight: "400",
        color: "#2E1E1E",
        margin: 5,
        maxWidth: 140
    },
});
